"use strict";
import { getWagmiConnectorV2 } from "@binance/w3w-wagmi-connector-v2";
import BINANCE_ICON from "assets/wallets/binance-icon.svg";
import { CONNECTION_PROVIDER_IDS } from "constants/web3";
import { createConnector } from "wagmi";
export function binanceWallet() {
  const baseConnectorFn = getWagmiConnectorV2()();
  return createConnector((config) => {
    const base = baseConnectorFn(config);
    return {
      ...base,
      id: CONNECTION_PROVIDER_IDS.BINANCE_W3W_CONNECTOR_ID,
      name: "Binance Wallet",
      type: "binanceWallet",
      icon: BINANCE_ICON
    };
  });
}
